import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Typography } from "@bookips/sds";
import { BILLING_NOTICE_SECTIONS } from "../constants/billing";
/** 월구독 결제방법 하단 안내 문구 (유의사항 / 결제 안내 / 해지 및 환불 안내) */ export const BillingNoticeSection = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "flex flex-col gap-3",
        children: BILLING_NOTICE_SECTIONS.map((param)=>/*#__PURE__*/ {
            let { title , items  } = param;
            return _jsxs("section", {
                className: "flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle2",
                        className: "text-secondary",
                        children: title
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "text-secondary typo-body2 flex flex-col pl-1",
                        children: items.map((item)=>/*#__PURE__*/ _jsx("li", {
                                className: cn("relative pl-5", "before:absolute before:top-[9px] before:left-1 before:size-[2px]", "before:rounded-full before:bg-current"),
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    as: "span",
                                    className: "text-secondary",
                                    children: item
                                })
                            }, item))
                    })
                ]
            }, title);
        })
    });
};
